import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { User } from '@app/shared/interfaces';
import { environment } from '@env/environment';

@Component({
  standalone: false,
  templateUrl: './direct-payouts-methods-add-stripe.component.html',
  styleUrls: ['./direct-payouts-methods-add-stripe.component.scss'],
})
export class DirectPayoutsMethodsAddStripeComponent implements OnInit {
  saving: boolean;

  stripePublicKey: string = null;
  stripeSecretKey: string = null;
  stripeName: string = null;

  all_properties: boolean = false;
  properties: any[] = [];

  user: User = this.auth.getUserDetails();

  redirect: string = '';

  constructor(
    private auth: AuthenticationService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    if (this.user.first_name) {
      this.stripeName = `${this.user.first_name}'s Stripe account`;
    }

    this.redirect = this.route.snapshot.queryParams.redirect;

    if (this.redirect) {
      localStorage.setItem('direct-stripe-redirect', this.redirect);
    }
  }

  setProperties(event: { all_properties: boolean; properties: any[] }) {
    this.all_properties = event.all_properties || false;
    this.properties = event.properties;
  }

  startStripeOauth() {
    window.location.href = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${environment.stripe.client_id}&scope=read_write`;
  }
}
